import styled from '@emotion/styled';
import { Flex } from 'antd';


export const Footer = styled(Flex)`
  margin-top: 24px
`;
